import { useWorkspaceInfoUsersById } from '@modules/workspace/providers/WorkspaceInfo/hooks/useWorkspaceInfoUsersById';
import { ChatChannelType, type ChatMessageListItem } from 'src/@types/chat';
import type { IWorkspaceUser } from 'src/@types/workspace-info';
import { useAuthContext } from 'src/auth/useAuthContext';
import { UserRecentFeature } from 'src/generated/graphql';
import { useSelector } from 'src/redux/store';
import { checkIfMutedChannel } from '../../sections/@dashboard/chat/ChatConversation/shared/utils';

export const useRecentsMessages = () => {
  const { user } = useAuthContext();
  const { usersById } = useWorkspaceInfoUsersById();

  const recentsMessages = useSelector((state) => {
    const { allIds, byId } = state.chat.conversations;

    if (!allIds.length) return null;

    return allIds.reduce((acc, id) => {
      const item = byId?.[id];

      const lastMessage = item.messages?.[0] as ChatMessageListItem;

      if (
        !item ||
        checkIfMutedChannel(user?._id || '', lastMessage, item.muteSettings)
      )
        return acc;

      if (item.type === ChatChannelType.TEXT && item.unreadMessages?.length) {
        let title = item.name;
        if (item.p2p) {
          const users = item.participants?.map(
            (p) => 'user' in p && usersById[p.user],
          ) as IWorkspaceUser[];
          const otherUser = users.find((u) => u?._id !== user?._id);
          title = otherUser?.name || item.name;
        }
        return [
          ...acc,
          {
            title,
            _id: item._id,
            feature: item.p2p
              ? UserRecentFeature.DirectMessage
              : UserRecentFeature.TextChannel,
            lastAccessAt: new Date(),
            objectRef: item._id,
            userId: item.createdBy,
            icon: '',
            url: `chat/${item._id || ''}`,
            workspaceId: item.workspace,
            priority: item.unreadMessages.length,
          },
        ];
      }

      return acc;
    }, [] as any[]);
  });

  return {
    recentsMessages,
  };
};
